<template>
  <div v-if="order">
    <a-row type="flex" justify="center" style="paddingBottom:55px">
      <a-col span="22">
        <a-steps :current="current" :status="status">
          <a-step
            v-for="item in tabs"
            :key="item.title"
            :title="item.title"
            :description="item.time"
          ></a-step>
        </a-steps>
      </a-col>
    </a-row>
    <a-divider></a-divider>
    <a-list itemLayout="vertical">
      <a-list-item-meta>
        <span slot="description">订单编号：{{ order.order_no }}</span>
        <b style="font-size:16px;color:#35B5FE" slot="title">订单状态：{{ order.status_text }}</b>
      </a-list-item-meta>
      <a-list-item style="padding-left:20px;">
        <h4>申请职位：{{ job.name }}</h4>
        <h4>申请公司：{{ job.company.name }}</h4>
        <!-- <h4>申请时间：{{ order.created_at }}</h4> -->
      </a-list-item>
    </a-list>
    <div class="order-info">
      <div class="btn" @click="viewMoreInfo = !viewMoreInfo" v-if="order.timelines.length > 1">
        <span v-show="!viewMoreInfo">
          展开
          <a-icon type="down"></a-icon>
        </span>
        <span v-show="viewMoreInfo">
          收起
          <a-icon type="up"></a-icon>
        </span>
      </div>
      <a-row type="flex" justify="start">
        <template v-for="(item, index) in order.timelines">
          <a-col :key="item.id" span="24" v-show="index === 0 || viewMoreInfo">
            <p :style="{ paddingLeft: index > 0 ? '30px' : '0' }">
              <a-icon v-if="index == 0" type="bell" style="margin-right:10px;" />
              {{
              `${item.user_name}&nbsp;&nbsp;&nbsp;&nbsp;${item.created_at}&nbsp;&nbsp;&nbsp;&nbsp;${item.post_status_name}`
              }}
            </p>
            <div class="reason" v-if="item.elimination_item && item.elimination_item.body">
              <p>原因：{{ item.elimination_item.body && item.elimination_item.body.reason_text.join(',') }}</p>
              <p style="padding-left:40px">{{ item.elimination_item.body && item.elimination_item.body.reason }}</p>
            </div>
            <!-- <div class="reason" v-if="item.elimination_reason.id > 0">
              <p>{{`原因：${item.elimination_reason.other_reasons}`}}</p>
              <p style="padding-left:40px">{{`${item.elimination_reason.reasons.join('，')}`}}</p>
              <p
                style="padding-left:40px"
                v-if="item.elimination_reason.expected_monthly_salary > 0"
              >{{`期待月薪：${item.elimination_reason.expected_monthly_salary}k/月`}}</p>
            </div> -->
          </a-col>
        </template>
      </a-row>
    </div>
    <a-tabs defaultActiveKey="0">
      <a-tab-pane tab="推荐信息" key="0">
        <recommand :source="order" @view="$refs.preview.show(order.report.attachment)"></recommand>
      </a-tab-pane>
      <a-tab-pane tab="职位信息" key="1">
        <job :source="job"></job>
      </a-tab-pane>
      <a-tab-pane tab="公司信息" key="2">
        <company :company="job.company"></company>
      </a-tab-pane>
      <a-tab-pane tab="猎头信息" key="3">
        <hunter :hunter="hunter"></hunter>
      </a-tab-pane>
      <a-tab-pane tab="面试信息" key="4">
        <interview :source="order"></interview>
      </a-tab-pane>
      <a-tab-pane tab="沟通与点评" key="5">
        <contact
          ref="contact"
          :resume="order.resume"
          :id="order.ie_user_id"
          @addSoft="$refs.commentModal.show(order)"
          @addCommunication="$refs.addCommunicationModal.show(order)"
        ></contact>
      </a-tab-pane>
    </a-tabs>
    <!-- //modal -->
    <resume-preview-modal ref="preview"></resume-preview-modal>
  </div>
</template>
<script>
import moment from "moment";
import Company from "./tabs/company";
import Contact from "./tabs/contact";
import Hunter from "./tabs/hunter";
import Interview from "./tabs/interview";
import Job from "./tabs/job";
import Recommand from "./tabs/recommand";
import ResumePreviewModal from "@/components/resume-preview-modal";
import Api from "@/api";
import baseComponentVue from "@/components/base-component.vue";
export default {
  name: "HunterOrderDetail",
  extends: baseComponentVue,
  props: {
    id: {
      default: -1
    }
  },
  data() {
    return {
      orderStatus: this.$route.params.status,
      viewMoreInfo: false,
      tabs: [],
      job: undefined,
      order: undefined,
      hunter: undefined
    };
  },
  components: {
    Company,
    Contact,
    Hunter,
    Interview,
    Job,
    Recommand,
    ResumePreviewModal
  },
  computed: {
    order_id() {
      if (this.id < 0) {
        return this.$route.params.id;
      } else {
        return this.id;
      }
    },
    //step
    current() {
      let status = this.order.status;
      let arr = [
        ["CREATED", "AUDIT_PASSED", "AUDIT_FAILED", "SUBMIT_FAILED"],
        ["SUBMIT_PASSED", "INTERVIEW", "INTERVIEW_FAILED", "CLOSED"],
        ["OFFERED"],
        ["ENTERED", "NOT_ENTERED"],
        ["COMPLETED", "NOT_COMPLETED"],
        ["UNSETTLED", "SETTLED"]
      ];
      return arr.findIndex(item => item.indexOf(status) > -1);
    },
    /**
     * return [-1(process),0(error),1(finish)]
     */
    status() {
      let status = this.order.status;
      let arr = [
        [
          "AUDIT_FAILED",
          "SUBMIT_FAILED",
          "INTERVIEW_FAILED",
          "CLOSED",
          "NOT_ENTERED",
          "NOT_COMPLETED"
        ],
        ["SETTLED"]
      ];
      let i = arr.findIndex(item => item.indexOf(status) > -1);
      return i == -1 ? "process" : i == 0 ? "error" : "finish";
    }
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      let { job, post: order, hunter } = await Api.order.getDetail({
        post_id: this.order_id
      });
      this.job = job;
      this.order = order;
      this.hunter = hunter;
      this.calcTabs(order.timelines);
    },
    calcTabs(lines) {
      let tabs = [
        { title: "推荐" },
        { title: "面试" },
        { title: "OFFER" },
        { title: "入职" },
        { title: "过保" },
        { title: "结算" }
      ];
      lines.forEach(item => {
        item.post_status == "CREATED" &&
          (tabs[0].time = moment(item.created_at).format("YYYY-MM-DD"));
        item.post_status == "INTERVIEW" &&
          (tabs[1].time = moment(item.created_at).format("YYYY-MM-DD"));
        item.post_status == "OFFERED" &&
          (tabs[2].time = moment(item.created_at).format("YYYY-MM-DD"));
        item.post_status == "ENTERED" &&
          (tabs[3].time = moment(item.created_at).format("YYYY-MM-DD"));
        item.post_status == "COMPLETED" &&
          (tabs[4].time = moment(item.created_at).format("YYYY-MM-DD"));
        item.post_status == "SETTLED" &&
          (tabs[4].time = moment(item.created_at).format("YYYY-MM-DD"));
      });
      this.tabs = [...tabs];
    },
  }
};
</script>
<style lang="scss" scoped>
.order-info {
  margin: 10px 0 38px;
  border: 1px solid #35b5fe;
  background: rgb(224, 244, 255);
  padding: 15px 20px 2px;
  position: relative;
  .btn {
    cursor: pointer;
    z-index: 10;
    position: absolute;
    right: 10px;
  }
  .reason {
    color: rgb(238, 88, 88);
    padding-left: 30px;
  }
}
</style>
